import { useEffect, useState } from "react";
import { API_URL, useAuth } from "./AuthContext";

// The tracker refreshes balances every few seconds and order history every minute, so
// polling faster than this wouldn't show anything new
const POLL_MS = 30 * 1000;

// Live overview stats for the trader's MT5 account (GET /api/trading-account/metrics).
// null until the first reading arrives, or while `enabled` is false. Cleared when
// `accountKey` changes (a free retry's new account), so no stale figures carry over.
export default function useAccountMetrics(enabled, accountKey) {
  const { token } = useAuth();
  const [metrics, setMetrics] = useState(null);

  useEffect(() => {
    setMetrics(null);
    if (!enabled) return undefined;

    let controller;
    const load = () => {
      controller?.abort();
      controller = new AbortController();
      fetch(`${API_URL}/api/trading-account/metrics`, {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      })
        .then((res) => (res.ok ? res.json() : null))
        // A failed poll keeps the last reading on screen rather than blanking the tiles
        .then((data) => data && setMetrics(data.metrics))
        .catch((err) => {
          if (err.name !== "AbortError") console.error("Failed to load account metrics:", err);
        });
    };

    load();
    const timer = setInterval(load, POLL_MS);
    return () => {
      clearInterval(timer);
      controller?.abort();
    };
  }, [enabled, token, accountKey]);

  return metrics;
}
